import { createContext } from 'react'

import { type FeatureFlags } from './FeatureFlags'

export const DEFAULT_FLAGS = {}

export const FeatureFlagContext = createContext<Partial<FeatureFlags>>(DEFAULT_FLAGS)
